export enum UserRole {
  PRACTITIONER = 'practitioner',
  TEAM_LEAD = 'team_lead',
  COMMS_ADMIN = 'comms_admin',
  ADMIN = 'admin',
}

export enum RaterType {
  SELF = 'self',
  PEER = 'peer',
  MANAGER = 'manager',
}

export enum AssessmentStatus {
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
}

export enum TrainingResourceType {
  DOCUMENT = 'document',
  VIDEO = 'video',
  COURSE = 'course',
}

export enum ScoreLabel {
  CRAWL = 'Crawl',
  WALK = 'Walk',
  RUN = 'Run',
}

export enum PeerInvitationStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
  EXPIRED = 'expired',
  COMPLETED = 'completed',
}

export enum InvitationDirection {
  INBOUND = 'inbound',
  OUTBOUND = 'outbound',
}
